import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./simple_loyalty_signup_mode.js";
//#region src/simple_loyalty_signup_mode_helper.ts
var simple_loyalty_signup_mode_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(simpleLoyaltySignupMode) {
	switch (simpleLoyaltySignupMode) {
		case 0: return "Off";
		case 1: return "Order Summary (GCN Only)";
		case 2: return "Payment Completed";
		case 3: return "Payment Completed | Forced";
	}
}
//#endregion
export { name, simple_loyalty_signup_mode_helper_exports };

//# sourceMappingURL=simple_loyalty_signup_mode_helper.js.map